/* eslint-disable no-nested-ternary */

import {
  useDispatch, useSelector,
} from 'react-redux';
import {
  actions,
} from 'Slice/FeedActivitiesSlice';
import {
  newsLoading,
  selectedNewsArticles,
  selectNewsPage,
  selectedNewsArticlesEnded,
  selectedNewsFilter,
  selectedPaginationLoading,
  selectNewsActivitiesFlurry,
} from 'Selector/FeedActivitiesSelector';
import { Article } from 'Types/ArticleTypes';
import InfiniteScroll from 'react-infinite-scroll-component';
import ArticleLoadingSkeletonBundle from 'Components/common/skeleton/ArticleLoadingSkeletonBundle';
import { Filter } from 'Types/FilterTypes';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import { useEffect } from 'react';
import { NODATABASEDONFILTERS } from 'Utils/Constants';
import ArticleListLoadingSkeletonBundle from 'Components/common/skeleton/ArticleListLoadingSkeletonBundle';
import ArticleGridLayout from 'Components/common/components/ArticleGridLayout';

type Props = {
  listview: boolean;
} & typeof defaultProps;

const defaultProps = {
  listview: false,
};

const NewsTab = function NewsTab(props: Props) {
  const dispatch = useDispatch();
  const loading: boolean = useSelector(newsLoading);
  const newsArticles: Article[] = useSelector(selectedNewsArticles);
  const page: number = useSelector(selectNewsPage);
  const articleEnded: boolean = useSelector(selectedNewsArticlesEnded);
  const selectedFilters: Filter[] = useSelector(selectedNewsFilter);
  const isPagination = useSelector(selectedPaginationLoading);
  const flurryObject = useSelector(selectNewsActivitiesFlurry);
  const { listview } = props;

  const fetchArticles = () => {
    const params = {
      page,
      ...(selectedFilters.length > 0 && { filters: selectedFilters }),
    };
    dispatch(actions.getNewsActivites(params));
  };

  const fetchMore = () => {
    if (newsArticles.length > 0) {
      fetchArticles();
    }
  };

  useEffect(() => {
    if (Object.keys(flurryObject).length) {
      dispatch(actions.setNewsActivitiesCall(true));
    }
  }, [flurryObject]);

  return (
    !loading && newsArticles.length === 0 ? (
      <NoPersonsFound title={NODATABASEDONFILTERS} />
    ) : (
      (
        <div id="tabs-details">
          <InfiniteScroll
            dataLength={newsArticles.length}
            next={fetchMore}
            hasMore={!articleEnded}
            loader={false}
            className="o-x-hidden o-y-hidden"
          >
            {loading
              ? (
                <ArticleLoadingSkeletonBundle />
              )
              : (
                <ArticleGridLayout
                  isLoading={isPagination}
                  articlesArray={newsArticles}
                  listview={listview}
                />

              )}
            {isPagination && !articleEnded && listview
              ? <ArticleListLoadingSkeletonBundle />
              : <ArticleLoadingSkeletonBundle />}
          </InfiniteScroll>
        </div>
      )
    )
  );
};

export default NewsTab;
